"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVirtualizedListbox = exports.createFilterOptions = exports.Autocomplete = void 0;
var lab_1 = require("@material-ui/lab");
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var useStyles = (0, styles_1.makeStyles)({
    listbox: {
        '& ul': {
            padding: 0,
            margin: 0,
        },
    },
    popper: {},
});
function Autocomplete(props) {
    var classes = useStyles(props);
    return react_1.default.createElement(lab_1.Autocomplete, __assign({ size: "small", classes: classes }, props));
}
exports.Autocomplete = Autocomplete;
exports.default = Autocomplete;
var lab_2 = require("@material-ui/lab");
Object.defineProperty(exports, "createFilterOptions", { enumerable: true, get: function () { return lab_2.createFilterOptions; } });
var useVirtualizedListbox_1 = require("./useVirtualizedListbox");
Object.defineProperty(exports, "useVirtualizedListbox", { enumerable: true, get: function () { return __importDefault(useVirtualizedListbox_1).default; } });
//# sourceMappingURL=index.js.map